import https from "@/api/api.js";
const state = {
  /** 案例的ID */
  caseId: "",
  /** 实训ID */
  experimentId: "",
  stage: 0,
  ALLhall: [],
  taskList: [],
  caseData: {
    // 案例不同阶段的基本信息
    // FORMULATE: {
    //   // 政策制定数据
    //   HallId: "", // 步骤大厅id
    //   tsId: "", // 大厅的场景ID
    //   stageShow: "", // 步骤信息
    //   task: [{}],
    //   taskHome: [] // 大厅下已完成的控件
    // },
    // EXECUTE: {
    //   // 政策执行数据
    //   stageShow: "", // 步骤信息
    //   HallId: "", // 步骤大厅id
    //   tsId: "", // 大厅的场景ID
    //   task: [{}],
    //   taskHome: [] // 大厅下已完成的控件
    // },
    // ASSESS: {
    //   // 政策评估数据
    //   stageShow: "", // 步骤信息
    //   HallId: "", // 步骤大厅id
    //   tsId: "", // 大厅的场景ID
    //   task: [{}],
    //   taskHome: [] // 大厅下已完成的控件
    // },
    // FINALITY: {
    //   // 政策终结数据
    //   stageShow: "", // 步骤信息
    //   tsId: "", // 大厅的场景ID
    //   HallId: "", // 步骤大厅id
    //   task: [{}],
    //   taskHome: [] // 大厅下已完成的控件
    // }
  }
};
const mutations = {
  doEditTaskList(store, data) {
    // 创建任务列表
    const storeData = store;
    storeData.taskList = data;
  },
  editAllHall(stote, data) {
    const stastoteData = stote;
    stastoteData.ALLhall[data.index] = data.data;
  },
  pushHallControl(data, v) {
    /** 添加大厅中的控件 */
    function find(value) {
      return value.id === v.data.id;
    }
    const data1 = data;
    console.log(v, v.data.id, data1.caseData[v.index].taskHome);
    console.log(data1.caseData[v.index].taskHome.findIndex(find));
    if (data1.caseData[v.index].taskHome.findIndex(find) >= 0) {
      //
      data1.caseData[v.index].taskHome[data1.caseData[v.index].taskHome.findIndex(find)] = v.data;
    } else {
      data1.caseData[v.index].taskHome.push(v.data);
    }
  },
  postStuCaseId(data, v) {
    /** 修改学生实训ID */
    const data1 = data;
    data1.caseId = v.caseExperimentId;
    data1.experimentId = v.experimentId;
  },
  async getDoCaseData(store, data) {
    console.log("执行", "docase");
    try {
      const { data: navList } = await https.getCaseHallNavbarList(data);
      navList.data.forEach(v => {
        store.caseData[v.caseStep] = {
          ...v,
          HallId: "", // 步骤大厅id
          tsId: "", // 大厅的场景ID
          stageShow: "", // 步骤信息
          task: [{}],
          taskHome: []
        };
      });
    } catch (error) {
      console.log(error);
    }
  },
  /** 修改阶段基本信息 */
  postStuCaseInformation(data, value) {
    const data1 = data;
    data1.caseData[value.index].tsId = value.tsId;
    data1.caseData[value.index].stageShow = value.stageShow;
  }
};
export default {
  state,
  mutations
};
